module.exports = __webpack_public_path__ + "static/icon1-16072d64e123c230508c210ed6185a26.png";